import config from '@/config/config'

const RouteView = {
  name: 'RouteView',
  render: h => h('router-view')
}

const visitorMode = Boolean(
  process.env.VUE_APP_VISITOR_MODE
)
/*
  meta 配置
  tabShow 是否展示底部导航
  keepAlive 是否需要缓存组件
  noLogin 页面是否开启免登录
  routerBack 是否显示返回按钮
  isGetUserSurplus 是否需要获取用户余额
  isGetUserInte 是否需要获取用户积分
  showHeadBar 是否展示头部
*/

const routeMap = [
  {
    path: '/user/bindTel',
    name: 'BindTel',
    component: () => import('@/views/user/bindTel'),
    meta: {
      name: '绑定手机号',
      noLogin: config.visitorMode
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/user/Login/index.vue'),
    meta: {
      name: '登录',
      noLogin: config.visitorMode,
      routerBack: false,
      showHeadBar: false
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/user/Register'),
    meta: {
      name: '注册',
      noLogin: config.visitorMode,
      showHeadBar: false
    }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/search/index.vue'),
    meta: { name: '搜索', noLogin: config.visitorMode }
  },
  {
    path: '/location',
    name: 'location',
    component: () => import('@/views/location'),
    meta: { name: '位置' }
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('@/views/product'),
    meta: {
      name: '商品',
      noLogin: config.visitorMode,
      keepAlive: true
    }
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import('@/views/order/orderList'),
    meta: { name: '订单' }
  },
  {
    path: '/orderInfo',
    name: 'orderInfo',
    component: () => import('@/views/order/orderDetail'),
    meta: { name: '订单详情' }
  },
  {
    path: '/myaddress',
    name: 'Myaddress',
    component: () => import('@/views/address/addressList'),
    meta: { name: '我的地址' }
  },
  {
    path: '/editaddress',
    name: 'editaddress',
    component: () =>
      import('@/views/address/addressDetail'),
    meta: { name: '修改地址' }
  },
  {
    path: '/orderhistory',
    name: 'orderhistory',
    component: () => import('@/views/order/orderHistory'),
    meta: { name: '订单记录' }
  },
  {
    path: '/service',
    name: 'service',
    // redirect: '/sceneval',
    component: () => import('@/views/service'),
    meta: { tabShow: true }
  },
  {
    path: '/userinfo',
    name: 'userInfo',
    component: () => import('@/views/userInfo'),
    meta: { name: '个人信息' }
  },
  // {
  // 	path: '/resetpassword',
  // 	name: 'resetPassword',
  // 	component: () => import('@/views/user/resetPassword'),
  // 	meta: { name: '忘记密码' },
  // },
  {
    path: '/welfare',
    name: 'welfare',
    component: RouteView,
    redirect: '/welfare/cardList',
    meta: { name: '我的福利' },
    children: [
      {
        path: '/welfare/cardList',
        name: 'WelfareCardList',
        component: () => import('@/views/welfare/cardList'),
        meta: { name: '福利卡列表' }
      },
      {
        path: '/welfare/cardDetail',
        name: 'WelfareCardDetail',
        component: () =>
          import('@/views/welfare/cardDetail'),
        meta: { name: '福利卡详情' }
      }
    ]
  },
  {
    path: '/prodetail',
    name: 'prodetail',
    component: () => import('@/views/prodetail'),
    meta: {
      name: '商品详情',
      noLogin: config.visitorMode,
      showHeadBar: true
    }
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/payment'),
    meta: { name: '确认订单' }
  },
  {
    path: '/paymentCashier',
    name: 'paymentCashier',
    component: () => import('@/views/paymentCashier'),
    meta: {
      name: '收银柜',
      isGetUserSurplus: true,
      showHeadBar: false
    }
  },
  // {
  //   path: '/mydiylist',
  //   name: 'myDiyList',
  //   component: () =>
  //     import('@/views/giftDiy/component/myDiyList'),
  //   meta: { name: '我的DIY' }
  // },
  {
    path: '/logistic',
    name: 'logistic',
    component: () => import('@/views/logistic'),
    meta: { name: '商品物流' }
  },
  // {
  //   path: '/makingCard',
  //   name: 'makingCard',
  //   component: () =>
  //     import('@/views/giftDiy/component/makingCard'),
  //   meta: { name: '个性定制' }
  // },
  {
    path: '/payOrderStatus',
    name: 'payOrderStatus',
    component: () => import('@/views/payOrderStatus'),
    meta: {
      name: '支付状态',
      showHeadBar: false
    }
  },
  {
    path: '/UserInfoHandle',
    name: 'UserInfoHandle',
    component: () => import('@/views/UserInfoHandle'),
    meta: {
      showHeadBar: false
    }
  },
  {
    path: '/bindTel',
    name: 'bindTel',
    component: () => import('@/views/bindTel')
  },
  {
    path: '/payment2',
    name: 'payment2',
    component: () => import('@/views/payment2'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/flash-sale',
    name: 'FlashSale',
    component: () => import('@/views/flashSale'),
    meta: { name: '限时抢购' }
  },
  {
    path: '/special-offer',
    name: 'SpecialOffer',
    component: () => import('@/views/specialOffer'),
    meta: { name: '特惠活动' }
  },
  {
    path: '/wallet',
    name: 'Wallet',
    component: () => import('@/views/wallet'),
    meta: { name: '我的钱包' }
  },
  {
    path: '/conpon',
    name: 'Conpon',
    redirect: '/conpon/list',
    component: RouteView,
    children: [
      {
        path: '/conpon/list',
        name: 'ConponList',
        component: () => import('@/views/conpon/conponList')
      },
      {
        path: '/conpon/detail',
        name: 'ConponDetail',
        component: () =>
          import('@/views/conpon/conponDetail')
      }
    ]
  },
  {
    path: '/myRecord',
    name: 'MyRecord',
    component: () => import('@/views/myRecord'),
    meta: { name: '我的足迹' }
  },
  {
    path: '/gitf',
    name: 'Gift',
    component: () => import('@/views/gift'),
    mete: { name: '礼包' }
  },
  {
    path: '/catering',
    name: 'Catering',
    component: () => import('@/views/catering'),
    meta: { name: '餐饮汇聚' }
  },
  {
    path: '/paymentPlatform',
    name: 'PaymentPlatform',
    component: () => import('@/views/paymentPlatform'),
    meta: { name: '支付平台' }
  },
  {
    path: '/mallModel',
    name: 'MallModel',
    component: () => import('@/views/mallModel'),
    meta: { name: '商城模板', noLogin: config.visitorMode }
  },
  {
    path: '/secondary',
    name: 'secondary',
    component: RouteView,
    redirect: '/secondary/home',
    // meta: { name: '二级页面' },
    children: [
      {
        path: '/secondary/home',
        name: 'SecondaryHome',
        component: () => import('@/views/secondary')
      },
      {
        path: '/secondary/brand',
        name: 'SecondaryBrand',
        component: () => import('@/views/secondary-brand')
      },
      {
        path: '/secondary/brandStore',
        name: 'SecondaryBrandStore',
        component: () =>
          import('@/views/secondary-brand-store')
      }
    ]
  },
  {
    path: '/platform',
    name: 'platform',
    component: () => import('@/views/platform'),
    meta: { name: '' }
  },
  {
    path: '/thirdPartLogin',
    name: 'thirdPartLogin',
    component: () => import('@/views/user/thirdPartLogin'),
    meta: {
      showHeadBar: false,
      noLogin: config.visitorMode
    }
    // meta: { name: '第三方登录' }
  },
  {
    path: '/nearbyStore',
    name: 'NearbyStore',
    component: () => import('@/views/nearbyStore'),
    meta: {
      name: '门店'
    }
  },
  {
    path: '/goods',
    name: 'Goods',
    component: () => import('@/views/goods'),
    meta: {
      name: '商品'
    }
  },
  {
    path: '/exchange',
    name: 'Exchange',
    component: RouteView,
    redirect: '/exchange/home',
    children: [
      {
        path: '/exchange/home',
        name: 'ExchangeHome',
        component: () => import('@/views/exchange/home'),
        meta: {
          name: '兑换',
          showHeadBar: false
        }
      },
      {
        path: '/exchange/goods',
        name: 'ExchangeGoods',
        component: () => import('@/views/exchange/goods'),
        meta: {
          name: '兑换商品'
        }
      },
      {
        path: '/exchange/settlement',
        name: 'ExchangeSettlement',
        component: () =>
          import('@/views/exchange/settlement'),
        meta: {
          name: '兑换结算'
        }
      }
    ]
  },
  {
    path: '/movie',
    name: 'movie',
    component: () => import('@/views/movie'),
    meta: {
      name: '电影'
    }
  }
]

export default routeMap
